import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/// Janela flutuante padrão dos cadastros: o formulário entra como children e
/// continua responsável pelos próprios botões de gravar/cancelar.
/// `maxWidth="lg"` vira tela cheia no mobile, onde não sobra espaço útil.
/// `footer` renderiza ações extras (ex.: anterior/próximo) abaixo do conteúdo.
export default function EntityFormDialog({
  open,
  title,
  subtitle,
  onClose,
  maxWidth = 'md',
  fullHeight = false,
  footer = null,
  children,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      PaperProps={{
        sx: fullHeight || fullScreen ? { height: fullScreen ? '100%' : '92vh' } : undefined,
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
        <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="h6" fontWeight={800} noWrap>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary" noWrap>
              {subtitle}
            </Typography>
          )}
        </Stack>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{ pt: 2, display: 'flex', flexDirection: 'column', minHeight: 0 }}
      >
        {open && children}
      </DialogContent>

      {footer && (
        <DialogActions
          sx={{
            px: 2,
            py: 1.25,
            justifyContent: 'space-between',
            gap: 1,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          {footer}
        </DialogActions>
      )}
    </Dialog>
  );
}
